import { omit } from 'lodash';
import { type IFramework } from '@/framework';
import { type ILayerProps } from '@/version-types';

/**
 * 更新舞台中的目标图层
 * @param framework - 框架实例
 * @param layer - 图层
 */
export const updateLayer = (framework: IFramework, layer: ILayerProps) => {
    framework.stage.addOrUpdate(layer);
    framework.operate.setActiveLayer(layer.id);
};

/**
 * 写入历史记录
 * @param framework - 框架实例
 * @param prevLayer - 更新前的图层
 * @param nextLayer - 更新后的图层
 * @param funcID - 功能 ID，主要用于埋点统计
 */
export const pushHistory = (framework: IFramework, prevLayer: ILayerProps, nextLayer: ILayerProps, funcID?: string) => {
    const prev = omit(prevLayer, '__isOnTextEditing');
    const next = omit(nextLayer, '__isOnTextEditing');
    framework.history.write(prev, next, funcID);
};
